import { Component, OnInit } from '@angular/core';

import { HomeService } from '../../home.service';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-recent-videos',
    templateUrl: './recent-videos.component.html',
    styleUrls: ['./recent-videos.component.scss'],
})
export class RecentVideosComponent implements OnInit {
    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno da coleção de dados solicitados a API
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    registers: any[];

    icons = {
        arrowRight: faCaretRight,
    };

    constructor(private homeService: HomeService) {}

    ngOnInit(): void {
        this.lastVideos();
    }

    /**
     * lastVideos() - Buscar últimos vídeos publicados
     */
    lastVideos() {
        //console.log('lastVideos');
        this.homeService.getLastVideos().subscribe(
            (returnSuccess) => {
                this.successCallbackApi(returnSuccess);
            },
            (returnFail) => {
                this.errorCallbackServer(returnFail);
            }
        );
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        this.registers = response.registers;
        //console.log(this.registers);
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro
        this.registers = null;
    }
}
